import type { SignedEntitlement } from "../domain/entitlement";
import { hakofitDesignType } from "../domain/pricing";

type ApiErrorPayload = {
  error?: string;
  message?: string;
};

type CreateCheckoutResponse = {
  sessionId: string;
  checkoutUrl: string;
};

type VerifySessionResponse = {
  paid: true;
  entitlement: SignedEntitlement;
};

type VerifyEntitlementResponse = {
  valid: boolean;
  expired: boolean;
  usable: boolean;
};

export async function createCheckoutSession(designHash: string): Promise<CreateCheckoutResponse> {
  return postJson<CreateCheckoutResponse>("/api/create-checkout", {
    designHash,
    designType: hakofitDesignType
  });
}

export async function verifyCheckoutSession(sessionId: string): Promise<VerifySessionResponse> {
  return postJson<VerifySessionResponse>("/api/verify-session", { sessionId });
}

export async function verifyEntitlement(entitlement: SignedEntitlement): Promise<VerifyEntitlementResponse> {
  return postJson<VerifyEntitlementResponse>("/api/verify-entitlement", { entitlement });
}

async function postJson<T>(url: string, body: unknown): Promise<T> {
  const response = await fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify(body)
  });
  const payload = (await response.json().catch(() => null)) as (T & ApiErrorPayload) | null;

  if (!response.ok) {
    throw new Error(payload?.message ?? "API request failed.");
  }

  if (!payload) {
    throw new Error("API response was empty.");
  }

  return payload;
}
